import { formatMoneyCents } from 'services/util'

import greenCheck from '../components/images/check-circle.svg'

import css from './sass/mypages.module.scss'

export default function MyDonationRow({auction}) {
  return (
    <div className={css['myitems-row']}>
      {/* <h3 className={css['mypages-headings']}>{item.Title}</h3> */}
      <div className={css['myitems-amount']}>
        <div className={css['myitems-amount-left']}>
          <p>Donation</p>
          <h2 className={css['mypages-headings']}>{`$${formatMoneyCents(auction.DonationTotal)}`}</h2>
        </div>
        <div className={css['myitems-amount-right']}>
          {auction.DonationPayment && <>
              <img className={css['myitems-paid-icon']} src={greenCheck} alt='Paid' />
              <p className={css['myitems-paid-text']}>Paid</p>
            </>
          }
        </div>
      </div>
    </div>
  )
}
